module.exports = __webpack_public_path__ + "media/images/no-device-connected-icon-df5cabd250bc4765708223b70d22d42b.svg";